module.exports = __webpack_public_path__ + "static/media/icon-error.f3223d59.svg";